import { Component, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AzureAuthService } from 'src/service/azure-auth.service';
import { ApplicationConfigService } from 'src/service/application-config.service';
import { NavigationItem } from 'src/app/models/navigation';
import { DistributionListEventSummary } from 'src/api/models';
import { ApplicationService, CustomerService, DistributionListService } from 'src/api/services';
import { CustomerSelection } from 'src/service/customer.service';

@Component({
  selector: 'app-public-header',
  templateUrl: 'public-header.template.html',
  styleUrls: ['./public-header.component.scss']
})

export class PublicHeaderComponent implements OnChanges {
  @Input() isPublic: boolean;

  public theme = 'dark';

  public dropdownIndex = -1;
  public activeRoute: string;
  
  public showAccountMenu: boolean;
  public timeZoneFilter: string;
  public customerFilter: string = "";

  showNavigation = false;

  constructor(
    private router: Router,
    public app: ApplicationConfigService,
  ) {
      // Watch for route changes
      router.events.subscribe(val => {
        const route: any = val;
        if (route.url) { this.activeRoute = route.url; }
      });

      this.timeZoneFilter = app.tenantTimeZone.split('/')[0];
    }

  ngAfterViewInit() {
  }

  ngOnChanges() {
  }

  ngOnInit(): void {
    
  }

  toggleTheme(){
    if (this.theme == 'dark'){
      this.theme = 'light'
    } else if (this.theme == 'light'){
      this.theme = 'dark'
    }
    var htmlElm = document.documentElement;
    //this.app.rootStyles = htmlElm.appendChild(document.createElement("style"));
    htmlElm.setAttribute("data-bs-theme",this.theme);
  }

  openDropdown(index: number) {
    this.dropdownIndex = index !== this.dropdownIndex ? index : -1;
  }

  checkVisible(item: NavigationItem) : boolean {
    return true;
  }
}
